<label class="filter-string-comparison__label">{{ label() }}</label>
<div class="filter-string-comparison__fields">
    <p-select placeholder="Select a comparison" [options]="comparisonOptions()" [optionLabel]="'label'"
        [optionValue]="'value'" [ngModel]="comparisonType()" (ngModelChange)="onChange.emit({ comparisonType: $event, compareWith: compareWith() })"
        styleClass="w-full"></p-select>
    <input class="filter-string-comparison__input" type="text" placeholder="Enter text" pInputText
        [ngModel]="compareWith()" (ngModelChange)="onChange.emit({ comparisonType: comparisonType(), compareWith: $event })" />
</div>